<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__tencenttargetings}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:tencenttargetings:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:tencenttargetings:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="targetingId" label="定向 id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="targetingName" label="定向名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="targeting" label="定向详细设置" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isIncludeUnsupportedTargeting" label="	是否包含不支持定向" header-align="center" align="center"></el-table-column>
        <el-table-column prop="description" label="定向描述" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isDeleted" label="是否已删除" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="lastModifiedTime" label="最后修改时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="targetingTranslation" label="已选择定向条件的描述" header-align="center" align="center"></el-table-column>
        <el-table-column prop="targetingSourceType" label="定向包来源
" header-align="center" align="center"></el-table-column>
        <el-table-column prop="shareFromAccountId" label="分享的源账户id
" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <!-- <el-button v-if="$hasPermission('sys:tencenttargetings:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button> -->
            <el-button v-if="$hasPermission('sys:tencenttargetings:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tencenttargetings-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/tencenttargetings/page',
        getDataListIsPage: true,
        exportURL: '/sys/tencenttargetings/export',
        deleteURL: '/sys/tencenttargetings',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
